(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["otsb-faq-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('r9-native-faq')) {
    class R9NativeFaq extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.querySelectorAll('[data-r9-faq-toggle]').forEach(button => {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel || !this.contains(panel)) return;
          button.setAttribute('aria-expanded', 'false');
          panel.hidden = true;
        });
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-r9-faq-toggle]');
          if (!button || !this.contains(button)) return;
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel || !this.contains(panel)) return;
          panel.hidden = !panel.hidden;
          button.setAttribute('aria-expanded', String(!panel.hidden));
        }, {signal:this.abort.signal});
        document.addEventListener('shopify:block:select', event => {
          if (!this.contains(event.target)) return;
          const item = event.target.closest('[data-r9-faq-item]');
          const button = item?.querySelector('[data-r9-faq-toggle]');
          const panel = item?.querySelector('[data-r9-faq-panel]');
          if (button && panel) {panel.hidden=false;button.setAttribute('aria-expanded','true');}
        }, {signal:this.abort.signal});
      }
      disconnectedCallback() {this.abort?.abort();this.abort=null;}
    }
    customElements.define('r9-native-faq', R9NativeFaq);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["otsb-logo-list-base"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('r9-native-carousel')) {
    class R9NativeCarousel extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.track = this.querySelector('.splide__track');
        if (!this.track) return;
        this.abort = new AbortController();
        const options = {signal:this.abort.signal};
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.breakpoint = matchMedia('(max-width: 1023px)');
        this.pauseButton = this.querySelector('[data-r9-logo-pause]');
        this.visible = false;this.hovered = false;this.paused = false;
        this.addEventListener('click', event => {
          if (event.target.closest('[data-r9-logo-pause]')) {
            this.paused = !this.paused;
            this.pauseButton.textContent = this.paused ? 'Retomar rotação' : 'Pausar rotação';
            this.update();
          } else if(event.target.closest('[data-r9-logo-prev]')) this.move(-1);
          else if(event.target.closest('[data-r9-logo-next]')) this.move(1);
        }, options);
        this.addEventListener('mouseenter',()=>{this.hovered=true;this.update();},options);
        this.addEventListener('mouseleave',()=>{this.hovered=false;this.update();},options);
        this.addEventListener('focusin',()=>this.update(),options);
        this.addEventListener('focusout',()=>queueMicrotask(()=>{if(this.isConnected)this.update();}),options);
        this.track.addEventListener('scroll',()=>this.progress(),{...options,passive:true});
        document.addEventListener('visibilitychange',()=>this.update(),options);
        this.motion.addEventListener('change',()=>this.update(),options);
        this.breakpoint.addEventListener('change',()=>this.update(),options);
        this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.update();});
        this.observer.observe(this);
        this.resize = new ResizeObserver(()=>{this.update();this.progress();});
        this.resize.observe(this.track);
        document.addEventListener('shopify:block:select',event=>{
          if (!this.contains(event.target)) return;
          this.paused=true;
          if(this.pauseButton)this.pauseButton.textContent='Retomar rotação';
          const item=event.target.closest('.splide__list > div');
          if(item)this.track.scrollBy({left:item.getBoundingClientRect().left-this.track.getBoundingClientRect().left,behavior:'instant'});
          this.update();
        },options);
        this.update();
      }
      enabled() {return (this.breakpoint.matches?this.dataset.mobile:this.dataset.desktop)==='true' && this.track.scrollWidth>this.track.clientWidth+2;}
      update() {
        clearInterval(this.timer);this.timer=null;
        const active=this.enabled();
        if(this.pauseButton)this.pauseButton.hidden=!active||this.motion.matches;
        if(active && this.dataset.autoplay==='true' && this.visible && !document.hidden && !this.hovered && !this.paused && !this.motion.matches && !this.contains(document.activeElement)) {
          this.timer=setInterval(()=>this.move(1),Math.max(1000,Number(this.dataset.interval)||5000));
        }
      }
      move(direction) {
        if(!this.enabled())return;
        const max=this.track.scrollWidth-this.track.clientWidth;
        const current=Math.abs(this.track.scrollLeft);
        let next=current+direction*this.track.clientWidth;
        if(direction>0 && current>=max-3)next=0;
        if(direction<0 && current<=3)next=max;
        const rtl=getComputedStyle(this.track).direction==='rtl';
        this.track.scrollTo({left:(rtl?-1:1)*Math.max(0,Math.min(max,next)),behavior:this.motion.matches?'instant':'smooth'});
      }
      progress() {
        const bar=this.querySelector('.splide-progress-bar');
        if(bar)bar.style.width=Math.min(100,(Math.abs(this.track.scrollLeft)+this.track.clientWidth)/Math.max(1,this.track.scrollWidth)*100)+'%';
      }
      disconnectedCallback() {clearInterval(this.timer);this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();this.abort=null;}
    }
    customElements.define('r9-native-carousel',R9NativeCarousel);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["r9-breadcrumb"] && !Shopify.designMode) return;
  try {
    (() => {
  const params = new URLSearchParams(location.search);
  const link = document.querySelector('[data-r9-journey-return]');
  const journeys = {
    'sentar-dormir': ['sofa-cama', 'Sentar e dormir'],
    'so-sentar': ['sofas', 'Só sentar'],
    'poltronas-kits': ['poltronas-1', 'Poltronas e kits'],
    'ja-tenho-base': ['futon', 'Já tenho a base']
  };
  const from = params.get('r9_from');
  if (!link || !Object.hasOwn(journeys, from)) return;
  const context = new URLSearchParams();
  context.set('r9_from', from);
  const size = params.get('r9_size');
  if (['all', 'compacto', 'solteiro', 'casal', 'king', '2-lugares', '3-lugares', 'poltrona', 'kit'].includes(size)) context.set('r9_size', size);
  const family = params.get('r9_family');
  if (family && /^[a-zA-Z0-9_-]{1,100}$/.test(family)) context.set('r9_family', family);
  const version = params.get('r9_version');
  if (version && /^\d{1,2}$/.test(version)) context.set('r9_version', version);
  const target = new URL(link.dataset.collectionsUrl + '/' + journeys[from][0], location.origin);
  target.searchParams.set('view', from);
  link.textContent = '← Voltar para ' + journeys[from][1];
  context.forEach((value, key) => { if (key !== 'r9_from') target.searchParams.set(key, value); });
  link.href = target.pathname + target.search;
  document.addEventListener('click', event => {
    const productLink = event.target.closest('a[href]');
    if (!productLink) return;
    const url = new URL(productLink.href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return;
    context.forEach((value, key) => url.searchParams.set(key, value));
    productLink.href = url.pathname + url.search + url.hash;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
